<template>
  <div ref="otpCont" class="d-flex justify-center">
    <input
        type="text"
        class="digit-box"
        v-for="(el, index) in digitCount"
        v-model="digits[index]"
        :key="el+index"
        :autofocus="index === 0"
        @keydown="handleKeyDown($event, index)"
        maxlength="1"
    />
  </div>
</template>

<script>

export default {
  props: {
    default: {
      type: String,
      default: ''
    },
    digitCount: {
      type: Number,
      required: true
    },
    timeToResend: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      time: 0,
      digits: [],
      isWaitingToResend: false,
      interval: undefined,
    }
  },
  computed: {
    defaultDigits: function() {
      return this.default && this.default.length === this.digitCount
          ? Array.from(this.default)
          : new Array(this.digitCount).fill(null);
    }
  },
  mounted() {
    this.digits = this.defaultDigits;
    this.time = this.$props.timeToResend;
  },
  created() {
    this.otpCont = this.$refs.otpCont;
  },
  methods: {
    isDigitsFull: function () {
      for (const elem of this.digits) {
        if (elem === null || elem === undefined) {
          return false;
        }
      }

      return true;
    },
    handleKeyDown(event, index) {
      if (
          event.key !== 'Tab' &&
          event.key !== 'ArrowRight' &&
          event.key !== 'ArrowLeft'
      ) {
        event.preventDefault();
      }

      if (event.key === 'Backspace') {
        this.digits.splice(index, 1, null);

        if (index !== 0) {
          this.$refs.otpCont.children[index - 1].focus();
        }

        return;
      }

      if (new RegExp('^([0-9])$').test(event.key)) {
        this.digits.splice(index, 1, event.key);

        if (index !== this.$props.digitCount - 1) {
          this.$refs.otpCont.children[index + 1].focus();
        }
      }

      if(this.isDigitsFull()){
         this.$emit('handle-code', this.digits.join(''));
      }
    }
  }
};
</script>

<style scoped>
.digit-box {
  height: 4rem;
  width: 4rem;
  border: 1px solid #c7c7c7;
  display: inline-block;
  border-radius: 5px;
  margin: 5px;
  padding: 15px;
  font-size: 3rem;
}

.digit-box:focus {
  outline: 2px solid #b2b2b2;
}

</style>